import { configureStore } from "@reduxjs/toolkit";

import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import { iffApi } from "../services/api";

import rootReducer from "./reducers";

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          "attachments/addAttachments",
        ],
        ignoredPaths: ["attachments.attachmentsToUpload"]
      },
    }).concat([iffApi.middleware]),
});

export default store;
